import { render, staticRenderFns } from "./ProjectPropertiesModal.vue?vue&type=template&id=3b1d1ec6&"
import script from "./ProjectPropertiesModal.vue?vue&type=script&lang=js&"
export * from "./ProjectPropertiesModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPropertiesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports